<template>
<div>
    <div class="flex flex-wrap flex-col md:flex-row">
        <div class="w-full md:w-1/2">
            <h1 class="mt-2 mb-4 md:mb-0 font-sans text-n-gray-dark">All Resources</h1>
        </div>
        <div class="w-full md:w-1/4 md:text-right mb-5 md:mb-0">
            <a href="#" class="button mb-12" @click.stop.prevent="exportResources">Export Resources</a>
        </div>
        <div class="w-full md:w-1/4 md:text-right mb-5 md:mb-0">
            <a href="#" class="button mb-12" @click.stop.prevent="syncResources">Sync Resources</a>
        </div>
    </div>
    <div class="flex flex-wrap">
        <div class="flex-1 mb-3">
            <input type="text" placeholder="Search title, creator user first name/last name, organization name" class="mb-4 search"
            v-on:keyup.enter="search"
            v-model="keyword">
        </div>
        <div class="w-full md:w-1/5">
            <button class="button mb-2" @click.stop.prevent="search">Search</button>
        </div>
        <div class="w-full md:w-1/5">
            <button class="button mb-2" @click.stop.prevent="clearSearch">Clear</button>
        </div>
    </div>
    <div class="responsive-table">
        <table class="w-full">
            <thead>
                <tr>
                    <th>Title</th>
                    <th>Creating User, Organization</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="this.isSearching && this.searchedResources.length < 1">
                    <td colspan="5" class="text-center font-bold">No search results</td>
                </tr>
                <admin-table-item
                    v-else
                    v-for="resource in filteredResources"
                    :key="resource.id"
                    :resource="resource"></admin-table-item>
            </tbody>
        </table>

        <div class="flex mt-8">
            <div class="w-1/2">
            <button class="mt-2"
                @click.stop.prevent="previous"
                :disabled="currentPage === 1"
                :class="{'opacity-50 cursor-not-allowed': currentPage === 1}">&lt;&lt; Previous</button>
            </div>

            <div class="w-1/2 text-right">
            <button class="mt-2"
                @click.stop.prevent="next"
                :disabled="currentPage === totalPages"
                :class="{'opacity-50 cursor-not-allowed': currentPage === totalPages}">Next &gt;&gt;</button>
            </div>
        </div>
    </div>
  <div class="w-full md:w-1/4 md:text-right mb-5 md:mb-0 mt-5">
    <router-link class="button mb-12" to="/resources/create">Create New Resource</router-link>
  </div>
</div>
</template>

<script>
    import { mapGetters } from "vuex";
    import AdminTableItem from "./AdminTableItem.vue";

    export default {
        name: "ResourceAdminTable",
        props: {},
        components: { AdminTableItem },
        data: () => ({
            keyword: "",
            searchedResources: {},
            isSearching: false,
            searchPagination: {
                current_page: 1
            }
        }),
        computed: {
            ...mapGetters({
                resources: "resources",
                pagination: "resourcePagination"
            }),
            currentPage() {
                if (this.isSearching) {
                    return this.searchPagination.current_page;
                }
                return this.pagination.current_page;
            },
            totalPages() {
                if (this.isSearching) {
                    return this.searchPagination.last_page;
                }
                return this.pagination.last_page;
            },
            filteredResources() {
                return this.searchedResources.length > 0
                    ? this.searchedResources
                    : this.resources;
            }
        },
        watch: {},
        methods: {
            search() {
                this.isSearching = true;

                axios
                    .get(
                        laroute.route("api.resources.search", {
                            keyword: this.keyword,
                            page: this.searchPagination.current_page
                        })
                    )
                    .then(response => {
                        this.searchedResources = response.data.data;
                        this.searchPagination = response.data.meta;
                    });
            },
            clearSearch() {
                this.keyword = "";
                this.searchedResources = {};
                this.searchPagination = {
                    current_page: 1
                };
                this.isSearching = false;
            },
            exportResources() {
                axios({
                    url: "/api/export/resources",
                    method: "GET",
                    responseType: "blob"
                }).then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "rihems-resources.csv");
                    document.body.appendChild(link);
                    link.click();
                });
            },
            syncResources() {
                this.$toasted.show("Syncing resources...");

                var route = this.$laroute.route("api.resources.sync");

                axios
                    .post(route)
                    .then(response => {
                        this.$toasted.show("Resources have been synced.");
                    })
                    .catch(error => {
                        console.log(error);
                        console.log(error.response);
                    });
            },
            previous() {
                if (this.isSearching) {
                    this.searchPagination.current_page =
                        this.searchPagination.current_page - 1;
                    this.search();
                } else {
                    var page = this.currentPage - 1;
                    this.$store.dispatch("getMoreResources", { page: page });
                }
                window.scrollTo(0, 0);
            },
            next() {
                if (this.isSearching) {
                    this.searchPagination.current_page =
                        this.searchPagination.current_page + 1;
                    this.search();
                } else {
                    var page = this.currentPage + 1;
                    this.$store.dispatch("getMoreResources", { page: page });
                }
                window.scrollTo(0, 0);
            }
        },
        mounted() {
            this.$store.dispatch("getAllResources");
        }
    };
</script>
